// import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// export default function CareerForm({payload,handleChange, handleSubmit}:any){
//     return(
// <form onSubmit={handleSubmit} className="space-y-6">

// <div className="form-group">
//   <label htmlFor="jobTitle" className="mb-1 font-medium">Job Title</label>
//   <TextField
//     name="jobTitle"
//     id="jobTitle"
//     placeholder="Enter job title"
//     value={payload.jobTitle}
//     onChange={handleChange}
//     variant="outlined"
//     fullWidth
//   />
// </div>

// <div className="form-group">
//   <label htmlFor="jobDescription" className="mb-1 font-medium">Job Description</label>
//   <TextField
//     name="jobDescription"
//     id="jobDescription"
//     placeholder="Enter job description"
//     value={payload.jobDescription}
//     onChange={handleChange}
//     multiline
//     rows={4}
//     variant="outlined"
//     fullWidth
//   />
// </div>

// <div className="form-group">
//   <label htmlFor="jobType" className="mb-1 font-medium">Job Type</label>
//   <TextField
//     name="jobType"
//     id="jobType"
//     placeholder="e.g., Full-time, Part-time"
//     value={payload.jobType}
//     onChange={handleChange}
//     variant="outlined"
//     fullWidth
//   />
// </div>

// <div className="form-group">
//   <InputLabel id="experience-label" className="mb-1 font-medium">Experience Level</InputLabel>
//   <FormControl fullWidth>
//     <Select
//       labelId="experience-label"
//       name="experienceLevel"
//       value={payload.experienceLevel}
//       onChange={handleChange}
//     >
//       <MenuItem value="">Select Experience Level</MenuItem>
//       <MenuItem value="Fresher">Fresher</MenuItem>
//       <MenuItem value="1 to 2 Years">1 to 2 Years</MenuItem>
//       <MenuItem value="2 to 5 Years">2 to 5 Years</MenuItem>
//       <MenuItem value="5 to 7 Years">5 to 7 Years</MenuItem>
//       <MenuItem value="More than 7 Years">More than 7 Years</MenuItem>
//     </Select>
//   </FormControl>
// </div>

// <div className="button-wrapper">
//   <Button type="submit" variant="contained" color="primary">

//     Submit Career Info
//   </Button>
// </div>
// </form>
//     )
// }
// // import React, { useState } from "react";
// // import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
// // import JoditEditor from "jodit-react";

// // export default function CareerForm({ payload, handleChange, handleSubmit }: any) {
// //   const [extraFields, setExtraFields] = useState<{ key: string; value: string }[]>([]);
// //   const [benefits, setBenefits] = useState<{ key: string; image: any }[]>([]);

// //   // Handle adding extra fields
// //   const addExtraField = () => {
// //     setExtraFields([...extraFields, { key: "", value: "" }]);
// //   };

// //   // Handle benefit image change (for Firebase)
// //   const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
// //     const file = e.target.files?.[0];
// //     if (!file) return;
// //     const buffer = await file.arrayBuffer();
// //     const imageBuffer = Buffer.from(buffer);
// //     const newBenefits = [...benefits];
// //     newBenefits[index].image = imageBuffer;
// //     setBenefits(newBenefits);
// //   };

// //   return (
// //     <form onSubmit={handleSubmit} className="space-y-6">
// //       {/* Job Title */}
// //       <div className="form-group">
// //         <label htmlFor="jobTitle" className="mb-1 font-medium">Job Title</label>
// //         <TextField
// //           name="jobTitle"
// //           id="jobTitle"
// //           placeholder="Enter job title"
// //           value={payload.jobTitle}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Job Description (TextField) */}
// //       <div className="form-group">
// //         <label htmlFor="jobDescription" className="mb-1 font-medium">Job Description</label>
// //         <TextField
// //           name="jobDescription"
// //           id="jobDescription"
// //           placeholder="Enter job description"
// //           value={payload.jobDescription}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //           multiline
// //           rows={4}
// //         />
// //       </div>

// //       {/* General Description (JoditEditor) */}
// //       <div className="form-group">
// //         <label htmlFor="generalDescription" className="mb-1 font-medium">General Description</label>
// //         <JoditEditor
// //           value={payload.generalDescription}
// //           onBlur={(newContent) => handleChange({ target: { name: "generalDescription", value: newContent } })}
// //           config={{
// //             readonly: false,
// //             height: 200
// //           }}
// //         />
// //       </div>

// //       {/* Education */}
// //       <div className="form-group">
// //         <label htmlFor="education" className="mb-1 font-medium">Education</label>
// //         <TextField
// //           name="education"
// //           id="education"
// //           placeholder="Enter required education"
// //           value={payload.education}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Notice Period */}
// //       <div className="form-group">
// //         <label htmlFor="noticePeriod" className="mb-1 font-medium">Notice Period</label>
// //         <TextField
// //           name="noticePeriod"
// //           id="noticePeriod"
// //           placeholder="Enter notice period"
// //           value={payload.noticePeriod}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Job Type */}
// //       <div className="form-group">
// //         <label htmlFor="jobType" className="mb-1 font-medium">Job Type</label>
// //         <TextField
// //           name="jobType"
// //           id="jobType"
// //           placeholder="Enter job type"
// //           value={payload.jobType}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Industry */}
// //       <div className="form-group">
// //         <label htmlFor="industry" className="mb-1 font-medium">Industry</label>
// //         <TextField
// //           name="industry"
// //           id="industry"
// //           placeholder="Enter industry"
// //           value={payload.industry}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Job Location */}
// //       <div className="form-group">
// //         <label htmlFor="jobLocation" className="mb-1 font-medium">Job Location</label>
// //         <TextField
// //           name="jobLocation"
// //           id="jobLocation"
// //           placeholder="Enter job location"
// //           value={payload.jobLocation}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Salary */}
// //       <div className="form-group">
// //         <label htmlFor="salary" className="mb-1 font-medium">Salary</label>
// //         <TextField
// //           name="salary"
// //           id="salary"
// //           placeholder="Enter salary range"
// //           value={payload.salary}
// //           onChange={handleChange}
// //           variant="outlined"
// //           fullWidth
// //         />
// //       </div>

// //       {/* Add Extra Fields (Key-Value Pair) */}
// //       <div className="form-group">
// //         <h4 className="font-medium">Custom Fields</h4>
// //         {extraFields.map((item, index) => (
// //           <div key={index} className="flex space-x-4">
// //             <TextField
// //               name={`key-${index}`}
// //               placeholder="Key"
// //               value={item.key}
// //               onChange={(e) => {
// //                 const newFields = [...extraFields];
// //                 newFields[index].key = e.target.value;
// //                 setExtraFields(newFields);
// //               }}
// //               variant="outlined"
// //               fullWidth
// //             />
// //             <TextField
// //               name={`value-${index}`}
// //               placeholder="Value"
// //               value={item.value}
// //               onChange={(e) => {
// //                 const newFields = [...extraFields];
// //                 newFields[index].value = e.target.value;
// //                 setExtraFields(newFields);
// //               }}
// //               variant="outlined"
// //               fullWidth
// //             />
// //           </div>
// //         ))}
// //         <Button variant="outlined" color="secondary" onClick={addExtraField}>+ Add Field</Button>
// //       </div>

// //       {/* Benefits (Key & Image Upload) */}
// //       <div className="form-group">
// //         <h4 className="font-medium">Benefits</h4>
// //         {benefits.map((item, index) => (
// //           <div key={index} className="flex space-x-4">
// //             <TextField
// //               name={`benefit-key-${index}`}
// //               placeholder="Benefit Key"
// //               value={item.key}
// //               onChange={(e) => {
// //                 const newBenefits = [...benefits];
// //                 newBenefits[index].key = e.target.value;
// //                 setBenefits(newBenefits);
// //               }}
// //               variant="outlined"
// //               fullWidth
// //             />
// //             <input
// //               type="file"
// //               accept="image/*"
// //               onChange={(e) => handleImageChange(e, index)}
// //               className="p-2"
// //             />
// //           </div>
// //         ))}
// //         <Button variant="outlined" color="secondary" onClick={() => setBenefits([...benefits, { key: "", image: null }])}>
// //           + Add Benefit
// //         </Button>
// //       </div>

// //       {/* Submit Button */}
// //       <div className="form-group">
// //         <Button type="submit" variant="contained" color="primary" fullWidth>
// //           Submit Career Info
// //         </Button>
// //       </div>
// //     </form>
// //   );
// // }

import React, { useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Button, MenuItem, Select, TextField } from "@mui/material";
import JoditEditor from "jodit-react";
import { ChevronRight } from "@mui/icons-material";
import { uploadImageToFirebase } from "../libs/utils";

// Zod schema for validation
const schema = z.object({
  id: z.string().optional(),
  jobTitle: z.string().min(1),
  jobDescription: z.string().min(1),
  jobType: z.string(),
  experienceLevel: z.string(),
  maxExperienceLevel:z.string(),
  education: z.string(),
  noticePeriod: z.string(),
  jobLocation: z.string(),
  industry: z.string(),
  salary: z.string(),
  generalDescription: z.string(),
  extraFields: z.array(z.object({ key: z.string(), value: z.string() })).optional(),
  benefits: z.array(z.object({ key: z.string(), image: z.any().nullable() })),
});

export type CareerFormValues = z.infer<typeof schema>;

export default function CareerForm({ onSubmit, defaultValues }: any) {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    register,
    formState: { errors }
  } = useForm<CareerFormValues>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues || {
      jobTitle: "",
      jobDescription: "",
      jobType: "",
      experienceLevel: "0",
      maxExperienceLevel:"1",
      education: "",
      noticePeriod: "",
      jobLocation: "",
      industry: "",
      salary: "",
      generalDescription: "",
      extraFields: [],
      benefits: [],
    },
  });

  useEffect(() => {
    if (defaultValues) {
       
      reset(defaultValues);
    }
  }, [defaultValues]);

  const { fields: extraFields, append: addExtraField, update: updateExtra, remove:removeExtraField } = useFieldArray({
    control,
    name: "extraFields",
  });

  const { fields: benefits, append: addBenefit, update: updateBenefit, remove:removeBenefit } = useFieldArray({
    control,
    name: "benefits",
  });



  return (
    <form onSubmit={handleSubmit(onSubmit)} className="" style={{marginTop: "20px",display: "flex", flexDirection: "column", gap: "20px"}}>
      

      {/* Static fields */}
      {["jobTitle", "jobDescription"].map((field) => (
        <div key={field}>
          <label className="mb-1 font-medium capitalize">{field.replace(/([A-Z])/g, ' $1')}</label>
          <TextField
            {...register(field as keyof CareerFormValues)}
            placeholder={`Enter ${field}`}
            variant="outlined"
            fullWidth
            error={!!errors[field as keyof CareerFormValues]}
            helperText={errors[field as keyof CareerFormValues]?.message?.toString()}
          />
        </div>
      ))}
  
      <h4 className="font-medium"><ChevronRight/> Other Details</h4>
      <div className="flex">
          <TextField value={"Job Type"} sx={{width:"300px"}} disabled/>
          <Controller
          name={"jobType"}
          control={control}
          render={({field})=>(
            <Select
                    value={field.value}
                    sx={{width:"300px"}}
                    // value={level}
                    displayEmpty
                    onChange={(value)=>field.onChange(value)}
                    // onChange={(e) => setLevel(e.target.value)}
                    renderValue={(selected) => selected ? selected as string : "Select Job Type"}
                  >
                    {/* <MenuItem value="">All Levels</MenuItem> */}
                    {/* <MenuItem value="">All Types</MenuItem> */}
                                        <MenuItem value="Part Time">Part Time</MenuItem>
                                        <MenuItem value="Contract">Contract</MenuItem>
                                        <MenuItem value="Full Time">Full Time</MenuItem>
                                        <MenuItem value="Permanent">Permanent</MenuItem>
                  </Select>
          )}
          />
          
          </div>
      {[
       {type:"number",label:"experienceLevel",placeholder:"Enter Minimum Experience level in years"}, 
       {type:"number",label:"maxExperienceLevel",placeholder:"Enter Maximum Experience level in years"}, 
       {type:"text",label:"education"}, 
       {type:"text",label:"noticePeriod"}, 
       {type:"text",label:"jobLocation"}, 
       {type:"text",label:"industry"}, 
       {type:"text",label:"salary"}
      ].map((field) => (
        <div key={field.label} className="flex">
          <TextField value={field.placeholder || field.label} placeholder="Key" sx={{width:"300px"}} disabled/>
          {/* <label className="mb-1 font-medium capitalize">{field.replace(/([A-Z])/g, ' $1')}</label> */}
          <TextField
          sx={{width:"300px"}}
            {...register(field.label as keyof CareerFormValues)}
            placeholder={field.placeholder || `Enter ${field.label}`}
            variant="outlined"
            
            type={field.type}
            error={!!errors[field.label as keyof CareerFormValues]}
            helperText={errors[field.label as keyof CareerFormValues]?.message?.toString()}
          />
        </div>
      ))}

      {/* Extra Fields */}
      <div>
        {/* <h4 className="font-medium">More Other Details</h4> */}
        {extraFields.map((item, index) => (
          <div key={item.id} className="flex space-x-4">
            <Controller
              name={`extraFields.${index}.key`}
              control={control}
              render={({ field }) => (
                <TextField {...field} placeholder="Key" sx={{width:"300px"}} />
              )}
            />
            <Controller
              name={`extraFields.${index}.value`}
              control={control}
              render={({ field }) => (
                <TextField {...field} placeholder="Value" sx={{width:"300px"}} />
              )}
            />

            <Button variant="outlined" color="error" onClick={() => removeExtraField(index)}>
              Remove
            </Button>
          </div>
        ))}

        <Button onClick={() => addExtraField({ key: "", value: "" })} variant="outlined" color="secondary">
          + Add Field
        </Button>
      </div>

      {/* Jodit Editor - General Description */}
      <div>
        <label className="mb-1 font-medium">General Description</label>
        <Controller
          name="generalDescription"
          control={control}
          render={({ field }) => (
            <Controller
              name="generalDescription"
              control={control}
              render={({ field }) => (
                <JoditEditor
                  value={field.value}
                  onBlur={(newContent) => field.onChange(newContent)}
                  config={{
                    readonly: false,
                    height: 200,
                    events: {
                      paste: (event: any) => {
                        const pastedText = event.clipboardData?.getData("text/html") || "";
                        const isValid = pastedText && pastedText.trim().length > 0 && pastedText !== "<p><br></p>";
                        if (!isValid) {
                          event.preventDefault(); // cancel paste
                          alert("Invalid content pasted.");
                        }
                      },
                    },
                  }}
                />
              )}
            />

          )}
        />
      </div>

      {/* Benefits */}
      <div>
        <h4 className="font-medium">Benefits</h4>
        {benefits.map((item, index) => (
          <div key={item.id} className="flex space-x-4">
            <Controller
              name={`benefits.${index}.key`}
              control={control}
              render={({ field }) => (
                <TextField {...field} placeholder="Benefit Key" fullWidth />
              )}
            />
            <Controller
              name={`benefits.${index}.image`}
              control={control}
              render={({ field }) => (
                <input
                  type="file"
                  accept="image/*"
                  onChange={async(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      const imageUrl = await uploadImageToFirebase(file,'career-images');
                      field.onChange(imageUrl);
                      // const reader = new FileReader();
                      // reader.onloadend = () => field.onChange(reader.result);
                      // reader.readAsDataURL(file);
                    }
                  }}
                  className="p-2"
                />
              )}
            />

            <Button variant="outlined" color="error" onClick={()=>removeBenefit(index)} >Remove</Button>
          </div>
        ))}

        <Button onClick={() => addBenefit({ key: "", image: null })} variant="outlined" color="secondary">
          + Add Benefit
        </Button>
      </div>

      <Button type="submit" variant="contained" color="primary" fullWidth>
        Submit Career Info
      </Button>
    </form>
  );
}
